export default {
  brand: 'txtify',
  domain: 'txtify.ru',
  title: 'txtify.ru — бесплатные инструменты для текста',
  description:
    'Быстрые локальные инструменты для текста: счётчик символов, слов, строк и размера UTF-8. Без регистрации и отправки текста на сервер.',
  metrikaId: '110026949',
  ogImage: 'https://txtify.ru/og-image.png',
}
